import React, { useState, useEffect} from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import Video from 'twilio-video';

const browserName = Tools.browserDetection();
const isMobile = Tools.isMobile();
const isIOS = Tools.isIos();
const isAndroid = Tools.isAndroid();
const isEdgeWebBrowser = browserName === "Edge" && !isMobile;

const edgeWebUrl = "https://www.microsoft.com/en-us/edge";
const androidChromeUrl = "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_US";
const chromeWebUrl = "https://www.google.com/chrome/";
const iosAppUrl = "https://itunes.apple.com/us/app/bsw-virtual/id1435618812";

const heading = isEdgeWebBrowser ? "Update required" : "Browser not supported";
const edgeMessage = "Your version of Edge needs to be upgraded to proceed with your video visit.";
const message = isEdgeWebBrowser ? edgeMessage : "We recommend using BSW Virtual with";
const upgradeIOSMessage = <>Your iOS needs to be upgraded to proceed with your video visit. <br />{`Go to Settings > General > Software Update.`}</>;
const upgradeIOSHeading = "Update required";
const { os, osVersion } = Tools.getOSInfo();
const isSupressMsgForMobIOS = os && os === "iOS" && isMobile && osVersion && osVersion[0] && osVersion[0] >= 14 && osVersion[1] && osVersion[1] >= 3;

const isiOSMobile = os && os === "iOS" && Tools.isMobile() && osVersion && osVersion[0];
const needIOSUpgrade = isiOSMobile && osVersion[0] == 15 && osVersion[1] && osVersion[1] == 1;
const BrowserErrorDialog = () => {
    const isSupportedBrowser = !needIOSUpgrade && (isSupressMsgForMobIOS || Video.isSupported) ? true : false;
    const [linkCopied, setLinkCopied] = useState(false);

    const copyLink = () => {
        logUI("UI.Login.CopyLink.Clicked", new Date(), Tools.getURLPath());
        const path = window.location.href;
        Tools.copyText(path);
        setLinkCopied(true);
    };

    useEffect(() => {
        if (!isSupportedBrowser) {
            const env = {
                browser: window.serverData.data.browser,
                browserVersion: window.serverData.data.browserVersion,
                os: os,
                osVersion: osVersion
            }

            logUI("UI.Login.Twilio.NotSupported", new Date(), Tools.getURLPath(), JSON.stringify(env));
        }

    }, []);

    return (
        <Modal isOpen={!isSupportedBrowser} centered className="browser-error-dialog">
            <ModalBody>
                <div className="browser-error">
                    <span className="svg-info" />
                    <h1 className="heading">{needIOSUpgrade ? upgradeIOSHeading : heading}</h1>
                    <div className="message">
                        {needIOSUpgrade
                            ? upgradeIOSMessage
                            : <>{message}
                                {!isEdgeWebBrowser && (isIOS ? ` Safari` : <a href={isAndroid ? androidChromeUrl : chromeWebUrl} target="_blank" onClick={() => logUI('UI.VideoVisit.Chrome.Clicked', new Date(), Tools.getURLPath())}>Google Chrome</a>)}
                            </>
                        }
                    </div>
                    {isEdgeWebBrowser ?
                        <a href={edgeWebUrl} target="_blank" className="btn btn-primary upgrade-btn" onClick={() => logUI('UI.VideoVisit.UpgradeEdge.Clicked', new Date(), Tools.getURLPath())}>UPGRADE</a> :
                        <React.Fragment>
                            {needIOSUpgrade
                                    ? <>You may also join through your <br />
                                        <a href={iosAppUrl} target="_blank">BSW Virtual App</a> or
                                        Google Chrome on Desktop.</>
                                    : <>Copy and paste the link below into {isIOS ? 'Safari' : 'Google Chrome'}</>
                                }
                            {!needIOSUpgrade &&
                                <div>
                                    <span className="copy-link">{window.location.href}</span>
                                    {linkCopied ?
                                        <button className="btn btn-check"><span className="icon-check" /></button>
                                        : <button className="btn btn-primary" onClick={copyLink}>Copy link</button>
                                    }
                                </div>
                            }
                            {linkCopied && <div className="link-success">Link is copied to clipboard.</div>}
                        </React.Fragment>
                    }
                </div>
            </ModalBody>
        </Modal>
    );
}

export default BrowserErrorDialog;